// @flow

import React from 'react';
import { I18n } from 'react-redux-i18n';
import { capitalizeLabel, removeAccents } from '../../../../utils/formatUtils';
import type { UrlParam } from '../../../../utils/urlUtils';
import { fuzzysearch } from '../../../../utils/fuzzysearch';
import CloseableComponent from '../../../common/CloseableComponent';
import type { CoqueRetailer } from '../../../../types/apolloType';

type Props = {
  placeholder: string,
  selectSources: { label: string, id: string, logo: ?string, selected?: boolean, type?: string, isLocomotive: boolean }[],
  handleChange: Function,
  locationParams: UrlParam,
  isFilterBarLoading: boolean,
  retailersDisplayed: CoqueRetailer[],
  isLoadingCustomRetailer: boolean,
}

type State = {
  searchWord: string,
  showOtherRetailers: boolean,
  addBp: boolean,
  inputFocused: boolean,
  sourceLoading: string,
}

class FindRetailer extends React.Component<Props, State> {
  state = {
    searchWord: '',
    showOtherRetailers: false,
    addBp: false,
    inputFocused: false,
    sourceLoading: '',
  };

  inputRef: ?HTMLInputElement;

  componentDidUpdate(prevProps: Props) {
    if ((this.props.selectSources !== prevProps.selectSources)
      && (this.props.locationParams.bp && this.props.selectSources && !this.state.addBp)) {
      if (this.state.searchWord === '') {
        this.handleChange(this.props.locationParams.bp);
      }
      const source = this.props.selectSources.filter(source => removeAccents(source.label) === removeAccents(this.props.locationParams.bp))[0];
      if (source && this.state.showOtherRetailers) {
        this.setState({ addBp: true, showOtherRetailers: false });
        this.props.handleChange(source.id);
      }
    }
    if ((this.props.selectSources === prevProps.selectSources)
      && this.props.locationParams.bp
      && this.state.showOtherRetailers
      && this.state.searchWord === this.props.locationParams.bp
      && !this.state.inputFocused
    ) {
      this.setState({ showOtherRetailers: false });
    }
  }

  handleChange = (value: string) => {
    this.setState({
      searchWord: value,
      showOtherRetailers: value.toString().length > 0,
      sourceLoading: '',
    });
  };

  handleClick = (valueId) => {
    this.setState({ sourceLoading: valueId });
    if (this.state.sourceLoading !== valueId) {
      this.props.handleChange(valueId);
    }
  };

  getSources = () => this.props.selectSources.filter((value) => {
    if (this.state.searchWord !== '' && value) {
      return fuzzysearch(this.state.searchWord, value.label);
    }
    return true;
  });

  render() {
    const sources = this.props.selectSources ? this.getSources() : [];
    return (
      <div className="select-retailer-container">
        <div className="input-retailer">
          <input
            type="search"
            onChange={e => this.handleChange(e.target.value)}
            placeholder={this.props.placeholder}
            onClick={() => this.setState({ inputFocused: true })}
            disabled={this.props.isFilterBarLoading}
            ref={(ref) => {
              if (ref && !this.inputRef) {
                this.inputRef = ref;
              }
            }}
          />
        </div>
        {
          this.state.showOtherRetailers
          && (
            <CloseableComponent
              isOpened={this.state.showOtherRetailers}
              toggle={() => this.setState({ showOtherRetailers: !this.state.showOtherRetailers })}
              buttonRef={this.inputRef}
            >

              <div
                role="presentation"
                className="select-retailer"
              >
                {
                  sources.length < 1
                    ? (
                      <button
                        className="retailer-filter"
                        key="empty"
                        onClick={() => {
                        }}
                      >
                        <p>
                          {I18n.t('comparator.noRetailerFound')}
                        </p>
                      </button>
                    ) : (
                      sources.map(value => (
                        <button
                          className={`retailer-filter${value.selected ? ' active' : ''} ${this.props.isLoadingCustomRetailer ? ' disabled' : ''}`}
                          key={value.id}
                          onClick={() => this.handleClick(value.id)}
                          disabled={this.props.isLoadingCustomRetailer}
                        >
                          { (this.props.isLoadingCustomRetailer
                            && this.state.sourceLoading === value.id) ?
                            (
                              <div className="retailer-search-result--spin">
                                <i className="fa fa-circle-notch fa-spin" />
                              </div>
                            ) :
                            (
                              <>
                                <div className="retailer-search-result">
                                  <p>
                                    {capitalizeLabel(value.label)}
                                  </p>
                                  {
                                    value.isLocomotive
                                    && (
                                      <div className="badge-locomotive">
                                        {I18n.t('tooltip.locomotive')}
                                      </div>
                                    )
                                  }
                                </div>
                                { value.logo ? (
                                  <div className="retailer-logo">
                                    <img src={value.logo} alt="logo" />
                                  </div>
                                  ) :
                                  (
                                    <div className="retailer-empty-logo">---</div>
                                  )
                                }
                              </>
                            )
                          }
                        </button>
                      ))
                    )
                }
              </div>
            </CloseableComponent>
          )}
      </div>
    );
  }
}

export default FindRetailer;
